import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './router';
import { RecoilRoot } from 'recoil';
import { ConfigProvider } from 'antd'
import './index.less';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

ReactDOM.render(
	<ConfigProvider locale={zhCN}>
		<RecoilRoot>
			<Routes />
		</RecoilRoot>
	</ConfigProvider>,
	document.getElementById('root')
);
